import React, { createContext, useState } from 'react';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [UpadateStatusData, SetUpadateStatusData] = useState(null);
  const [NewRequest, setNewRequest] = useState(null);
  const [Invoice, setInvoice] = useState(null);
  const [AttendanceSocket, setAttendanceSocket] = useState(null);
  const [BreakSocket, setBreakSocket] = useState(null);

  return (
    <AppContext.Provider value={{
      UpadateStatusData, SetUpadateStatusData,
      NewRequest, setNewRequest,
      Invoice, setInvoice,
      AttendanceSocket, setAttendanceSocket,
      BreakSocket, setBreakSocket
    }}>
      {children}
    </AppContext.Provider>
  );
};
